import {Tour} from 'nextstepjs';
import {useIsMobileByScreen} from 'core/hooks/useIsMobileByScreen';

export const useGetSteps = (): Tour[] => {
    const isMobile = useIsMobileByScreen();
    const resolution = isMobile ? 'MOBILE' : 'DESKTOP';
    const expressOrderSelector = `#EXPRESS_ORDER_TOOLTIP_${resolution}_BUTTON`;

    return [
        {
            tour: 'mainTour',
            steps: [
                {
                    title: 'Express Order Step DT - not for display purpose',
                    content: '',
                    selector: expressOrderSelector,
                    icon: undefined,
                    pointerRadius: 12,
                    pointerPadding: 0,
                },
            ],
        },
    ];
};
